(function() {
  'use strict';

  angular.module('component.eventTypes')
    .component('eventTypePreview', {
      templateUrl: 'app/components/event-types/form.preview.html',
      controller: 'EventTypePreviewController',
      controllerAs: 'eventTypePreviewCtrl',
      bindings: {
        eventTypeId: '<'
      }
    });
})();
